import React from 'react';
import { jumpTo } from '@/navigate'
import './index.scss';
import scene from '../three/index';
import BgAudio from "./bgAudio";


class App extends React.Component {
    state = {
        barWidth: "0%"
    }
    componentWillUnmount(){
        this.threescene.deinit();
    }

    componentDidMount() {
        
        let s = scene;
        let loaded = false;
        let scope = this;

        s.init(this.refs.container, ()=>{
            //s.changeState(0);
            loaded = true;
            if( !scope.timmer) {
                jumpTo("guide5");
            }
        });
        this.threescene = s;

        scope.timmer = setInterval(() => {
            let width = parseInt(this.state.barWidth);
            width = width + 1;
            this.setState({
                barWidth: width + "%"
            }, () => {
                if (width == 100 ) {
                    clearInterval(scope.timmer);
                    scope.timmer = null;
                    if( loaded ) jumpTo("guide5");
                }
            })
        }, 70);
    }

    render() {
        return (
            <div className="page page-guide guide_room_2">
                <div className="threescene hide" ref="container"></div>
                <div className="loading_view">
                    <div className="loading_txt">接下来，请进行针刺操作!</div>
                    <div className="loading_bar_view">
                        <div className="bar" style={{ width: this.state.barWidth }}></div>
                    </div>
                    <audio src={require("../../assets/audio/step_5_loading.mp3")} autoPlay={true}/>
                </div>
                <BgAudio/>
            </div >
        );
    }
}

export default App;
